export default __webpack_public_path__ + "static/media/card-back-square.5de15128.jpg";